import React, { useState, useContext, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  DatePicker
} from "@material-ui/pickers";
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { List, ListItem, TextField, MenuItem } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Service from "../services/service";
import * as actions from '../actions/actions';
import AddIcon from "@material-ui/icons/Add";
import { IconButton } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    flexDirection: "column",
    display: "flex",
    overflowY: "auto",
    padding: 0,
    width: '100%'
  },
  date_format: {
    padding: "0 !important",
  },
  action_block: {
    textAlign: "center",
    paddingBottom: "10px",
    margin: '0 16px',
    display: 'none'
  },
  text_filed_container: {
    width: '100%'
  },
  button_block: {
    width: '100%',
    display: 'none'
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  width_80: {
    width: '80%'
  },
  addProject: {
    marginTop: "16px",
    textAlign: "right",
    width: "20%",
    cursor: "Pointer"
  }
}));

export default function LibraryPropertiesForm(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);
  const { library, validation } = props;

  const [propertyData, setPropertyData] = useState({
    date: (library && library.Date && library.Date !== '0000-00-00 00:00:00') ? new Date(library.Date) : new Date(),
    title: (library && library.Name) ? library.Name : '',
    author: (library && library.Author) ? library.Author : '',
    projectid: (library && library.ProjectId) ? library.ProjectId : "",
    comment: (library && library.Comment) ? library.Comment : '',
  });

  // update the local props when library has been updated
  useEffect(() => {
    //alert(JSON.stringify(library));
    resetLibrary();
  }, [JSON.stringify(library)]);

  const resetLibrary = () => {
    setPropertyData({
      ...propertyData,
      title: (library && library.Name) ? library.Name : '',
      date: (library && library.Date && library.Date !== '0000-00-00 00:00:00') ? new Date(library.Date) : new Date(),
      author: (library && library.Author) ? library.Author : '',
      projectid: (library && library.ProjectId) ? library.ProjectId : '',
      comment: (library && library.Comment) ? library.Comment : '',
    });
  }

  // check Validatation for library form
  const validateFormSubmit = (type, key) => {
    if (type && key) {
      if (library && type === 'Scheduled' && new Date(library[type === 'Scheduled' ? 'Date' : type]).getTime() === new Date(propertyData[key]).getTime()) {
        return false
      }
      if ((library && library[type === 'Scheduled' ? 'Date' : type] === propertyData[key]) || ((!library[type === 'Scheduled' ? 'Date' : type]) && (!propertyData[key]))) {
        return false
      }
    }
    if (!validation) {
      if (!propertyData.date) {
        const toastrAlert = {
          type: "error",
          message: s.notificationMessage.dateRequired,
          status: true
        }
        dispatch(actions.openToast(toastrAlert))
        return false
      }
      if (propertyData.title.trim() === '') {
        const toastrAlert = {
          type: "error",
          message: s.notificationMessage.titleRequired,
          status: true
        }
        dispatch(actions.openToast(toastrAlert))
        return false
      }
    }
    return true
  }

  const onConfirmUpdate = (key) => {
    state.selectedLibraryIds.length && Service.UpdateLibraries({ ...propertyData, field: key }, state.selectedLibraryIds).then(res => {
      if (res.success) {
        Service.getLibrary(library.Id).then(res => {
          dispatch(actions.get_library(res.data || []));
          dispatch(actions.notifyLibrariesChanged());
        });
      } else {
        dispatch(actions.openToast({ type: "false", message: res.errors[0], status: true }));
      }
    });
  }

  const onCancelUpdate = () => {
    resetLibrary();
  }


  // action While Submit library form
  const handleSubmit = (e, type, key) => {
    e.preventDefault();

    // this is a draft library only used in new plag check, no need for update
    if (!library.Id) {
      //alert(JSON.stringify(propertyData));
      dispatch(actions.setDraftLibrary(propertyData));
      return;
    }

    let validate = validateFormSubmit(type, key);
    if (!validate)
      return;

    if (state.selectedLibraryIds.length > 1) {
      dispatch(actions.openConfirmationDialog({
        title: s.libraryOverview.updateTexts.format(state.selectedLibraryIds.length),
        text: s.libraryOverview.updateTextsDesc,
        onConfirm: () => onConfirmUpdate(key),
        onCancel: () => onCancelUpdate(),
        hint: s.libraryOverview.updateTextsHint
      }));
    } else {
      onConfirmUpdate();
    }
  }

  const createProjectPopup = () => {
    dispatch(actions.create_project_popup(true));
  }

  return (

    <div className={classes.root}>
      <form className={classes.form} noValidate autoComplete="off" onSubmit={handleSubmit}>
        {/* List item start */}
        <List>
          {library.Id ?
            <ListItem>
              <div className={classes.text_filed_container}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    required
                    label={s.date}
                    autoOk
                    size="small"
                    format="dd-MM-yyyy"
                    className={`${classes.text_filed_container} ${classes.date_format}`}
                    value={propertyData.date}
                    onBlur={(e) => handleSubmit(e, 'Scheduled', 'date')}
                    onChange={(date) => setPropertyData({ ...propertyData, date: date })}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </ListItem>
            : ""}
          <ListItem>
            {validation ?
              <div className={classes.text_filed_container}>
                <TextField
                  className={classes.text_filed_container}
                  size="small"
                  label={s.title}
                  value={propertyData.title}
                  onBlur={(e) => handleSubmit(e, 'Name', 'title')}
                  onChange={(evt) =>
                    setPropertyData({ ...propertyData, title: evt.target.value })
                  }
                />
              </div> :
              <div className={classes.text_filed_container}>
                <TextField
                  required
                  className={classes.text_filed_container}
                  size="small"
                  label={s.title}
                  value={propertyData.title}
                  onBlur={(e) => handleSubmit(e, 'Name', 'title')}
                  onChange={(evt) =>
                    setPropertyData({ ...propertyData, title: evt.target.value })
                  }
                />
              </div>}
          </ListItem>
          <ListItem>
            <div className={classes.text_filed_container}>
              <TextField
                className={classes.text_filed_container}
                label={s.author}
                size="small"
                value={propertyData.author}
                InputProps={{ endAdornment: "" }}
                onBlur={(e) => handleSubmit(e, 'Author', 'author')}
                onChange={(evt) =>
                  setPropertyData({ ...propertyData, author: evt.target.value })
                }
              />
            </div>
          </ListItem>
          <ListItem>
            <div className={classes.width_80}>
              <TextField
                size="small"
                select
                className={classes.text_filed_container}
                label={s.project}
                value={propertyData.projectid > 0 ? propertyData.projectid : ""}
                onBlur={(e) => handleSubmit(e, 'ProjectId', 'projectid')}
                onChange={(e) =>
                  setPropertyData({ ...propertyData, projectid: e.target.value })
                }>
                <MenuItem key={0} value={0}>
                  [{s.noProject}]
                </MenuItem>
                {state.projects.map((option) => (
                  <MenuItem key={option.Id} value={option.Id}>
                    {option.Name}
                  </MenuItem>
                ))
                }
              </TextField>
            </div>
            <div className={classes.addProject}>
              <IconButton onClick={() => { createProjectPopup(); }}>
                <AddIcon />
              </IconButton>
            </div>
          </ListItem>
          <ListItem>
            <div className={classes.text_filed_container}>
              <TextField
                multiline
                className={classes.text_filed_container}
                size="small"
                label={s.notes}
                value={propertyData.comment || ""}
                onBlur={(e) => handleSubmit(e, 'Comment', 'comment')}
                onChange={(evt) =>
                  setPropertyData({ ...propertyData, comment: evt.target.value })
                }
              />
            </div>
          </ListItem>
        </List>
        <Button className={classes.button_block} type="submit">
          {s.submit}
        </Button>
        {/* List item end */}
      </form>
    </div>
  );
};
